import React from "react";
import { ErrorText } from "../components/GeneralStyles/GeneralStyles";
import { loginUrl } from "./env";

export const getErrorTextComponent = (error: any): JSX.Element => {
  let content: JSX.Element;
  const supportLink = (
    <a href="https://verbit-ai.zendesk.com/hc/en-us" style={{ color: "inherit" }}>
      Customer Support
    </a>
  );

  const loginLink = (
    <a href={loginUrl} style={{ color: "inherit" }}>
      try logging in instead
    </a>
  );

  switch (error.code) {
    case "UsernameExistsException":
      content = <span>It appears that you recently attempted to sign up. Try logging-in instead. For further assistance, contact {supportLink}.</span>;
      break;
    case "InvalidPasswordException":
      content = <span>Your password does not meet the required criteria. For support, contact {supportLink}.</span>;
      break;
    case "InvalidParameterException":
      content = <span>Please check your input and try again. Need help? Contact {supportLink}.</span>;
      break;
    case "InvalidEmailFormatException":
    case "InvalidPhoneNumberException":
      content = <span>The email or phone number format is invalid. For help, contact {supportLink}.</span>;
      break;
    case "TooManyRequestsException":
      content = <span>Too many requests. Please try again later. For assistance, contact {supportLink}.</span>;
      break;
    case "NotAuthorizedException":
      content = <span>You are not authorized to perform this operation. Contact {supportLink}.</span>;
      break;
    case "UserLambdaValidationException":
      if (error.message.includes("phone number already exists")) {
        content = (
          <span>
            It appears that you recently attempted to sign up. Try again within the hour using the same phone number or {loginLink}. For assistance, contact{" "}
            {supportLink}.
          </span>
        );
      } else if (error.message.includes("Cannot self-signup this email for this template")) {
        content = <span>This email domain is currently not allowed. Please use a different email. Need help? Contact {supportLink}.</span>;
      } else {
        content = <span>User validation failed. Please check your input. Need help? Contact {supportLink}.</span>;
      }
      break;
    default:
      return <ErrorText>Something went wrong and we could not create your account. Please try again or contact {supportLink}.</ErrorText>;
  }

  return <ErrorText>{content}</ErrorText>;
};
